import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import { cn } from '@/lib/helper/utils';
import { Plus, X } from 'lucide-react';
import { Controller } from 'react-hook-form';
export const TagsInputForm = ({ formMethods, className, fieldName, required, errorMessage, placeholder }) => {
    const { control, formState: { errors }, getValues } = formMethods;
    let color;
    let client = getValues('client');
    if (client) {
        color = `theme-${client.themeColor}`;
    }
    else {
        color = 'quaternary';
    }
    return (_jsx(Controller, { name: fieldName, control: control, rules: {
            required: required
                ? errorMessage || 'This field is required'
                : false,
        }, render: ({ field }) => (_jsx(TagsInput, { value: field.value || [], onChange: field.onChange, error: errors[fieldName]?.message, placeholder: placeholder, className: className, color: color })) }));
};
export const TagsInput = ({ value, onChange, error, placeholder, className, color }) => {
    const inputRef = useRef(null);
    const tags = value || [];
    const [isAdding, setIsAdding] = useState(false);
    const [input, setInput] = useState('');
    useEffect(() => {
        if (!isAdding)
            return;
        const handleClickOutside = (e) => {
            if (inputRef.current && !inputRef.current.contains(e.target)) {
                if (input.trim()) {
                    addTag();
                }
                else {
                    setIsAdding(false);
                }
                setInput('');
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isAdding, input, tags]);
    const addTag = () => {
        const trimmed = input.trim();
        if (!trimmed || tags.includes(trimmed))
            return;
        onChange([...tags, trimmed]);
        setInput('');
        setIsAdding(false);
    };
    const removeTag = (tag) => {
        onChange(tags.filter((t) => t !== tag));
    };
    const exitInputMode = () => {
        setInput('');
        setIsAdding(false);
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            addTag();
        }
        else if (e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            exitInputMode();
        }
    };
    return (_jsxs("div", { className: cn('flex flex-wrap gap-1', className), children: [tags.map((tag) => (_jsxs("div", { className: `flex items-center bg-${color} text-constant-primary px-3 py-[2px]  rounded-full text-base gap-1`, children: [tag, _jsx("button", { type: "button", onClick: () => removeTag(tag), className: "hover:text-button-red hover:opacity-100 text-black opacity-20", children: _jsx(X, { className: 'w-4 h-4' }) })] }, tag))), isAdding ? (_jsx("input", { ref: inputRef, type: "text", value: input, onChange: (e) => setInput(e.target.value), onKeyDown: handleKeyDown, autoFocus: true, className: "px-3 py-1 rounded-full border border-primary bg-background text-sm w-28 focus:outline-none", placeholder: placeholder })) : (_jsxs("button", { type: "button", onClick: () => setIsAdding(true), className: `flex items-center text-secondary border border-secondary pr-3 pl-2 py-[2px]  rounded-full text-base gap-1`, children: [_jsx(Plus, { className: 'w-4 h-4' }), "Add"] })), error && (_jsx("div", { className: "text-button-red text-sm w-full mt-1", children: error }))] }));
};
